import { apiCall } from '../../services/apiUtil';
import { uploadFile } from '../../services/imageUploadService';

/**
 * Service for handling team logo/image uploads to S3
 * New taxonomy: teams/{teamId}/logo.jpeg → stored in DB as /images/teams/{teamId}/logo.jpeg
 */
class TeamImageService {
  /**
   * Upload a logo image for a team
   * @param {Blob} croppedBlob - The cropped image blob (JPEG)
   * @param {number|string} teamId - The team ID
   * @returns {Promise<string>} - The stored path: /images/teams/{teamId}/logo.jpeg
   */
  async uploadTeamLogo(croppedBlob, teamId) {
    const result = await uploadFile(
      croppedBlob,
      'team_assets',
      'logo.jpeg',
      teamId ? `${teamId}/logo.jpeg` : undefined
    );
    return result.url;
  }

  /**
   * Legacy: Get presigned URL for a bare filename stored in DB
   * @param {number|string} teamId - The team ID
   * @param {string} filename - The logo filename (bare, not /images/ path)
   * @returns {Promise<string|null>} - Presigned URL or null
   */
  async getTeamLogoUrl(teamId, filename) {
    try {
      if (!filename) return null;
      const key = filename.includes('/') ? `teams/${filename}` : `teams/${teamId}/${filename}`;
      return `/images/${key}`;
    } catch (error) {
      console.error('[TeamImageService] Error getting team logo URL:', error);
      return null;
    }
  }
}

export default new TeamImageService();
